import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {Checkbox} from "@pg-design/checkbox";
import {flex, mr, onDesktop, order} from "@pg-design/helpers-css";

import {usePropertyTypeFilter} from "../../../../../utils/hooks/usePropertyTypeFilter";
import {capitalize} from "../../../../../utils/misc";
import {FilterOfferType} from "../../../common/app/constants/enums";

export const PropertyTypeFilter = () => {
    const {t} = useTranslation();
    const {activeFilter, filter} = usePropertyTypeFilter();

    return (
        <div css={filters}>
            <Checkbox
                css={[mr(8), onDesktop(mr(2))]}
                name="flats_checkbox"
                id="flats_checkbox"
                labelContent={capitalize(t("common.flats.nominative"))}
                onChange={() => filter(FilterOfferType.FLATS)}
                checked={!activeFilter || activeFilter === FilterOfferType.FLATS}
                checkedMarkColor="var(--green-checkbox-checked)"
            />

            <Checkbox
                css={mr(4)}
                name="houses_checkbox"
                id="houses_checkbox"
                labelContent={capitalize(t("common.houses.nominative"))}
                onChange={() => filter(FilterOfferType.HOUSES)}
                checked={!activeFilter || activeFilter === FilterOfferType.HOUSES}
                checkedMarkColor="var(--green-checkbox-checked)"
            />
        </div>
    );
};

const filters = css`
    ${flex()};
    flex: 0 0 auto;
    ${order(3)}

    ${onDesktop(order(1))}
`;
